import { isAxiosError } from 'axios';

/** ProblemDetails `code` the Org Hub API sets when OrgHub.IsEnabled is off for the caller's root org. */
export const ORG_HUB_NOT_ENABLED_CODE = 'OrgHubNotEnabled';

/*
 * Recognizes the one 403 that means "Org Hub isn't enabled for your org": the API access gate's
 * ProblemDetails tagged `code: OrgHubNotEnabled`, optionally naming the org (`orgName`). Any other failure —
 * including a 403 from a permission check, scope check or the BFF — returns null, so it is never shown as
 * "not enabled".
 */
export function readOrgHubNotEnabled(error: unknown): { orgName: string | null } | null {
    if (!isAxiosError(error) || error.response?.status !== 403) {
        return null;
    }

    const data: unknown = error.response.data;
    if (typeof data !== 'object' || data === null) {
        return null;
    }

    const { code, orgName } = data as { code?: unknown; orgName?: unknown };
    if (code !== ORG_HUB_NOT_ENABLED_CODE) {
        return null;
    }

    return { orgName: typeof orgName === 'string' && orgName.trim() ? orgName.trim() : null };
}
